import { __awaiter, __generator } from "tslib";
import { FluidHostContext } from '@office-start/fluid-service';
import { fetchIdentity } from '@office-start/identity-service';
import { getOfficeRouteParamsFromDriveItem } from '@office-start/office-route-utility';
import { OfficeRouteItemType, OfficeWorkload, } from '@office-start/officehome-types';
import { markFluidBootPerformance } from '@office-start/performance-service';
import { getLaunchInstrumentationParamsFromKnownArea } from './getLaunchInstrumentationParamsFromKnownArea';
import { launchUrl } from './launchUrl';
export function launchFluidContent(fluidAppDetails, fluidHostFile, officeComponentContext, area) {
    return __awaiter(this, void 0, void 0, function () {
        var startTime, identity, fluidHostContext, docId, docUrl, driveId, fileType, siteUrl, route, officeRouteParams, param, action, url;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    startTime = Date.now();
                    return [4 /*yield*/, fetchIdentity()];
                case 1:
                    identity = _a.sent();
                    fluidHostContext = new FluidHostContext(officeComponentContext, identity, 'DocumentClick');
                    markFluidBootPerformance(officeComponentContext.correlationId, fluidHostContext.getBootId());
                    fluidHostContext.hostScenarioName = 'DocumentClick';
                    fluidHostContext.hostScenarioStartTime = startTime;
                    docId = fluidAppDetails.docId, docUrl = fluidAppDetails.docUrl, driveId = fluidAppDetails.driveId, fileType = fluidAppDetails.fileType, siteUrl = fluidAppDetails.siteUrl;
                    route = {
                        route: 'Content',
                        type: OfficeRouteItemType.Base,
                        app: fileType,
                    };
                    officeRouteParams = getOfficeRouteParamsFromDriveItem(driveId, docId, docUrl, fluidHostFile ? { siteUrl: siteUrl } : {});
                    param = getLaunchInstrumentationParamsFromKnownArea(area, undefined, 'Fluid');
                    action = 'OpenInBrowser';
                    // This is a temporary workaround to bypass an unsafe-eval CSP violation in V1 app, generate a url string and pass it to launchUrl to force launching fluid doc in new tab.
                    // TODO: Revert the change after react app is fully rolled out or fluid doc redirect to loop app.
                    if (officeComponentContext.workload !== OfficeWorkload.OfficeHomeReact) {
                        url = officeComponentContext.router.getUrlForRoute(route, officeRouteParams) || '';
                        return [2 /*return*/, launchUrl(url, { action: action }, param, officeRouteParams)];
                    }
                    return [2 /*return*/, launchUrl(route, { action: action }, param, officeRouteParams)];
            }
        });
    });
}
//# sourceMappingURL=launchFluidContent.js.map